// extracted by mini-css-extract-plugin
export default {"productGrid":"TZ-z","centerLink":"UZ-z","productSection":"VZ-z","item":"WZ-z","ctaButton":"XZ-z"};